import React from 'react';
import { useMutation } from 'react-fetching-library';
import { Card, CardContent, CardHeader, Box, TextField, Button, Alert, Stack } from '@mui/material';
import { Logo } from '../../../components/landing/Logo';
import { verifyDocumentCodeAction } from '../../../services/request';
import { useParams } from 'react-router-dom';

export default function PasswordBox({ id, setIsCodeValid, setIsSigned, setSigningDueDateExceeded, setSigningDueDate, setPayload, setParentCode = null }) {
  const { annex_nr, model, module_identifier } = useParams();
  const [code, setCode] = React.useState('');
  const { error, mutate } = useMutation(verifyDocumentCodeAction);

  const handleChange = e => {
    setCode(e.target.value);
  };

  const handleSubmit = async () => {
    const { payload, error, loading } = await mutate(id, { code, annex_nr, model });
    if (!error && !loading) {
      if (payload.success === true) {
        setIsCodeValid(true);
        if (setParentCode) {
          setParentCode(code);
        }
        setIsSigned(payload.is_signed);
        setSigningDueDateExceeded(payload.signing_due_date_exceeded);
        setSigningDueDate(payload.signing_due_date);
        setPayload(payload);
      }
    }
  };

  return (
    <Box sx={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack alignItems="center" spacing= {2}>
        <Logo/>
        <Card sx={{ width: '400px', margin: 'auto' }}>
          <CardHeader title={module_identifier == 'obozy' ? 'PODAJ OTRZYMANY W PIERWSZYM SMS-IE KOD' : 'PODAJ OTRZYMANY W 2. E-MAILU KOD DOSTĘPU DO UMOWY'} />
          <CardContent>
            <TextField value={code} onChange={handleChange} fullWidth inputProps={{ style: { textAlign: 'center', fontSize: '26px' }, maxLength: 16 }}></TextField>
            {error ? <Alert severity="error" sx={{ mt: 2 }}>Niepoprawny kod</Alert> : null}
            <Button variant="contained" fullWidth disabled={code.length < 10} sx={{ mt: 2, textTransform: 'none' }} onClick={handleSubmit}>{Number(annex_nr) ? 'ZAPOZNAJ SIĘ I ZAAKCEPTUJ ANEKS' : 'ZAPOZNAJ SIĘ I ZAAKCEPTUJ UMOWĘ'}</Button>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
};

